import { Injectable } from '@angular/core';
import { AngularFirestoreCollection, AngularFirestore } from 'angularfire2/firestore';
import * as firebase from 'firebase';

@Injectable({
  providedIn: 'root'
})
export class EventService {
  eventsCollectionRef: AngularFirestoreCollection<any>;
  eventsDraftCollectionRef: AngularFirestoreCollection<any>;
  dbEvents = firebase.firestore().collection('events');
  constructor(private angularFirestore: AngularFirestore) {
    this.eventsCollectionRef = this.angularFirestore.collection('events');
    this.eventsDraftCollectionRef = this.angularFirestore.collection('drafts');
    // console.log('time', firebase.firestore.FieldValue.serverTimestamp());
  }

  add(data) {
    data.createdAt = firebase.firestore.FieldValue.serverTimestamp();
    return this.eventsCollectionRef.add(data);
  }

  getAll() {
    return this.eventsCollectionRef.valueChanges();
  }

  getAllSort() {
    return this.dbEvents;
  }

  getOneAll() {
    return this.eventsCollectionRef.ref.get();
  }

  getById(id) {
    return this.eventsCollectionRef.doc(id).valueChanges();
  }

  getOneById(id) {
    return this.eventsCollectionRef.doc(id).ref.get();
  }

  addDraft(data, id?) {
    data.updateAt = firebase.firestore.FieldValue.serverTimestamp();
    return this.eventsDraftCollectionRef.doc(id || 'addEvent').set(data);
  }

  addDraftEdit(data) {
    data.updateAt = firebase.firestore.FieldValue.serverTimestamp();
    return this.eventsDraftCollectionRef.doc('addEventEdit').set(data);
  }

  removeDraft(data) {
    return this.eventsDraftCollectionRef.doc('addEvent').delete();
  }

  getDraft(id) {
    return this.eventsDraftCollectionRef.doc(id).ref.get();
  }

  updateIdEvent(uid) {
    return this.eventsCollectionRef.doc(uid).update({ id: uid });
  }

  updateEvent(uid, data) {
    data.updateAt = firebase.firestore.FieldValue.serverTimestamp();
    this.eventsCollectionRef.doc(uid).update(data);
  }
}
